export default __webpack_public_path__ + "static/media/profile-ownership.03f0cc6a.svg";